<template>
  <div>
      <div v-if="this.$store.state.langchange1">{{ updatedata() }}</div>
  <footer id="footer" v-if="!loading">
    <!--<div class="footer-image mobile-inactive"></div>-->
    <div class="
    mt-3">
      <div class="row footer-width text-center" style="width: 100%">
        
        
         

          <div class="text-center">
          <div class="social-linkes mt-4">
            <a v-if="DBitems.social.instgram" target="_blank" :href="DBitems.social.instgram">
              <i class="bi bi-instagram"></i>  
            </a>
            <a v-if="DBitems.social.twiter" target="_blank" :href="DBitems.social.twiter"
              ><i class="bi bi-twitter-x"></i></a>
            <a v-if="DBitems.social.facebook" target="_blank" :href="DBitems.social.facebook"
              ><i class="bi bi-facebook"></i></a>
             <a v-if="DBitems.social.tiktok" target="_blank" :href="DBitems.social.tiktok">
              <i class="bi bi-tiktok"></i></a>
            <a v-if="DBitems.social.whatsapp" target="_blank" :href="'https://api.whatsapp.com/send?phone='+DBitems.social.whatsapp+'&text=Hello!'"
              > <i class="bi bi-whatsapp"></i></a>
            <a v-if="DBitems.social.snapchat" target="_blank" :href="DBitems.social.snapchat"
              ><i class="bi bi-snapchat"></i></a>
              <a v-if="DBitems.social.email" target="_blank" :href="'mailto:'+DBitems.social.email"
              ><i class="bi bi-envelope"></i></a>

              <a v-if="DBitems.social.phone" target="_blank" :href="'to:'+DBitems.social.phone"
              ><i class="bi bi-telephone-outbound"></i></a>
          </div>

          <hr>
          <div class="d-flex justify-content-around">

          <div class="country_footer">
          <select v-model="country" @change="change_country" id="country"
            class="select_country_footer">
            <option v-for="(item, index) in this.countries" :value="item.id">{{ item.unit }} | {{ item.name }}</option>
          </select>
        </div>

          <div class="lang">
         <select  id="lang" @change="onChange" :title="$t('lang')">
          <option :value="$i18n.locale" selected  style="text-align:center">{{ $t('lang') }}</option>
          <option value="en" style="text-align:center">English</option>
          <option value="ar" style="text-align: center;">العربية</option>
         </select>
        </div>

      </div>
        
       

        <div class="social-linkes1 mt-4"><!-- v-if="DBitems.social.andrioad_link!=null"-->
            <a v-if="DBitems.social.andrioad_link!=null" target="_blank" :href="DBitems.social.andrioad_link"
              ><img class="m-1" src="../../../public/assets/image/icons/Google play.png"
            /></a>
            <a v-if="DBitems.social.ios_link!=null" target="_blank" :href="DBitems.social.ios_link"
              ><img class="m-1" src="../../../public/assets/image/icons/App Store.png"
            /></a>
          </div>
        </div> 

      </div>
    </div>
    <div  class="copy_right"style="text-align: center;
    ">
    <p v-if="DBitems.market.copy_right" style="
    margin: 2% !important;" onclick="window.open('https://etrolley.net', '_blank');">
     {{ DBitems.market.copy_right }}
    </p>

      </div>
  </footer>
  </div>
</template>

<script>
//import { KinesisContainer, KinesisElement} from 'vue-kinesis'
export default {
  // eslint-disable-next-line
  /*eslint-disable */
  name: "Footer",
  //components:{ KinesisContainer, KinesisElement },
  props: {
    // msg: String,
  },
  data: function () {
    return {
      //storeName: "markat",
      logo: "",
      DBitems: null,
      loading: false,
      country: 6,
      countries: [],
    };
  },
  created() {
    this.loading = true;
    this.$store.storeName = this.$store.state.storeName;
    console.log(this.$store.storeName);
    this.axios
      .get(this.$store.state.base_api_url + this.$store.storeName + "/footer",
      {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        })
      .then((response) => (this.DBitems = response.data.data))
      .then(() => (this.loading = false));


      this.axios
          .get(
            this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
            {
              headers: {
                "Accept-Language": this.$i18n.locale
              }
            }
          )
          .then(response => {
            this.countries = response.data.data;
          })

          .then(() => (this.loading = false));
  },
  methods: {
    updatedata() {
      this.loading = true;
    this.$store.storeName = this.$store.state.storeName;
    console.log(this.$store.storeName);
    this.axios
      .get(this.$store.state.base_api_url + this.$store.storeName + "/footer",
      {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        })
      .then((response) => (this.DBitems = response.data.data))
      .then(() => (this.loading = false));
      this.$store.state.langchange1 = false;
    },
    onChange() {
     var lang= document.getElementById('lang').value;
      this.$store.state.langchange = true;
      this.$store.state.langchange1 = true; //for footer
      this.$i18n.locale = lang;
      this.$router.replace({ params: { lang: this.$i18n.locale } })

      if (lang == "ar") {
        this.$store.state.UnitPrice = this.$store.state.unitAR

        document.documentElement.setAttribute("dir", "rtl");
        document.title = this.$store.state.title_ar;
        document.getElementById("description_meta").content = this.$store.state.description_ar;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
        let h = document.querySelector('body');
        h.setAttribute('dir', 'rtl')
      } else {
        this.$store.state.UnitPrice = this.$store.state.unit

        document.documentElement.setAttribute("dir", "ltr");
        document.title = this.$store.state.title_en;
        document.getElementById("description_meta").content = this.$store.state.description_en;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_en;

        let h = document.querySelector('body');
        h.setAttribute('dir', 'ltr')
      }
      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/sections_theme2",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
          this.headerSections = response.data.data;
        })
        .then(() => (this.loading = false));

      if (this.$localStorage.get(this.$store.storeName) != null) {
        this.loadingNote = true;
        this.axios
          .get(
            this.$store.state.base_api_url +
            this.$store.storeName +
            "/new_note",
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
                Authorization:
                  "Bearer " + this.$localStorage.get(this.$store.storeName),
              },
            }
          )
          .then((response) => {
            if (response.data.data.code == "1") {
              this.notifications = response.data.data.notes;
              //console.log(this.notifications);
            }
          })
          .then(() => {
            this.loadingNote = false;
          });

      }

      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.countries = response.data.data;
          console.log('gggg', this.countries)

        })
        .then(() => (this.loading = false));
    },
    change_country() {
      //////////////////////////
      console.log('///////////////////////////////////////////////////////////////////////////////////')
      console.log(this.country)
      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/currencyv1/" + this.country,
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.$store.state.rate = response.data.data.rate
          this.$store.state.unit = response.data.data.unit_en
          this.$store.state.unitAR = response.data.data.unit_ar
          this.$store.state.country_code = response.data.data.country_code;
          this.$store.state.country_flag = response.data.data.country_flag;
          this.$store.state.country_length = response.data.data.country_length;
          if (this.$i18n.locale == 'ar') {
            this.$store.state.UnitPrice = this.$store.state.unitAR;
          }
          else {
            this.$store.state.UnitPrice = this.$store.state.unit;
          }

        })
        .then(() => (this.loading = false));


      ///////////////////////////////
    },

  },
  watch:{
    lang(newVal) {
      this.$store.state.langchange = true;
      this.$store.state.langchange1 = true; //for footer
      this.$i18n.locale = newVal;
      this.$router.replace({ params: { lang: this.$i18n.locale } })

      if (lang == "ar") {
        this.$store.state.UnitPrice = this.$store.state.unitAR

        document.documentElement.setAttribute("dir", "rtl");
        document.title = this.$store.state.title_ar;
        document.getElementById("description_meta").content = this.$store.state.description_ar;
        document.getEleme
        ntById("keywords_meta").content = this.$store.state.keyword_ar;
        let h = document.querySelector('body');
        h.setAttribute('dir', 'rtl')
      } else {
        this.$store.state.UnitPrice = this.$store.state.unit

        document.documentElement.setAttribute("dir", "ltr");
        document.title = this.$store.state.title_en;
        document.getElementById("description_meta").content = this.$store.state.description_en;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_en;

        let h = document.querySelector('body');
        h.setAttribute('dir', 'ltr')
      }
    
     

     
    }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#footer{
  background-color: #222;
  color: #fff;
   height: 100%;
   min-height: 350px;
  
}

    #footer .logo {
        margin-bottom: 10px;
    }

    #footer h3 {
        font-size: 1.5rem;
        font-weight: 700;
        color: #14151c;
        position: relative;
        padding: 0;
        margin: 0 0 15px 0;
    }

    #footer h2 {
        font-size: 22px;
        font-family: "Araboto-Black";
        font-weight: 700;
        color: #fff ;
        position: relative;
        padding: 0;
        margin: 0 0 15px 0;
    }

    #footer p {
        color: #d8d8d8;
        font-family: "Araboto-Medium";
        font-size: 14px;
        padding: 0;
        margin: 0 0 15px 0;
    }

    #footer a p:hover {
          color: #fff;
    }

    #footer .contact-info p {
        color: var(--primary-color);
        font-family: "Araboto-Bold";
        font-size: 15px;
    }

    #footer .contact-info p:hover {
        text-decoration: underline;
    }

    #footer .button:hover {
        transform: scale(1.01);
        box-shadow: 0 2px 29px 0 #a3a3a3;
    }

    #footer .social-linkes img:hover {
        transform: scale(1.1);
    }

    .mobile-active {
        display: none !important;
    }

    .mobile-inactive {
        display: block !important;
    }
 @media (max-width: 992px) {
        #footer h3 {
            text-align: center;
            font-size: 1.3rem;
            line-height: 1.3rem;
        }

        #footer p {
            text-align: center;
            font-size: 0.8rem;
            line-height: 1rem;
        }

        #footer h2 {
            font-size: 0.8rem;
            line-height: 1rem;
            text-align: center;
        }

        #footer .logo {
            justify-content: center;
        }

        #footer .social-linkes {
            justify-content: center;
            align-items: center;
            display: flex;
        }

        .footer-width {
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
        }
    }

    @media (max-width: 350px) {
        #footer h3 {
            text-align: center;
            font-size: 1.2rem;
            line-height: 1.2rem;
        }

        #footer p {
            font-size: 0.6rem !important;
            line-height: 1rem;
        }

        #footer h2 {
            font-size: 0.6rem;
            line-height: 1rem;
        }

        #footer .logo {
            justify-content: center;
        }
    }
    @media only screen and (max-width: 600px) {

.footer_saved
{
        float: none !important;
    margin: 0px !important;
    position: relative;
    right: 0px !important;
    /* pointer-events: none; */
}

.footer_saved2
{
        float: none !important;
    margin: 0px !important;
    position: relative;
    right: 0px !important;
    /* pointer-events: none; */
}
}
</style>
